import { ServiceFeeBasePoint } from './type';

export const dropDownServiceFeeBasePoint: ServiceFeeBasePoint[] = [
  { name: '20 cents', value: '20' },
  { name: '10 cents', value: '10' },
  { name: '0 cents', value: '0' }
];

export enum FeatureToggleState {
  ALWAYS_ON = 'always_on',
  ON_BY_DEFAULT = 'on_by_default',
  OFF_BY_DEFAULT = 'off_by_default'
}

export const dropDownSignatureRequestOption: { name: string; value: FeatureToggleState }[] = [
  { name: 'On by default', value: FeatureToggleState.ON_BY_DEFAULT },
  { name: 'Off by default', value: FeatureToggleState.OFF_BY_DEFAULT },
  { name: 'Always On', value: FeatureToggleState.ALWAYS_ON }
];

export const dropDownServiceFeeOption: { name: string; value: FeatureToggleState }[] = [
  { name: 'On by default', value: FeatureToggleState.ON_BY_DEFAULT },
  { name: 'Off by default', value: FeatureToggleState.OFF_BY_DEFAULT },
  { name: 'Always On', value: FeatureToggleState.ALWAYS_ON }
];

export enum CustomizationsUpdateType {
  TIPS = 'tips',
  TNC = 'tnc',
  LIMITS = 'limits',
  REVIEW_LINK = 'review-link',
  PAYMENT_METHOD = 'payment-method',
  SIGNATURE = 'signature',
  SERVICE_FEE = 'service-fee',
  DISCOUNT = 'discount',
  ESTIMATE_TNC = 'estimate-tnc'
}

export const defaultTerms = 'Thank you for choosing us, please find our Terms & Conditions below-';

export const termsMaxCount = 8000;
export const notesMaxCount = 2000;

export const defaultTipChoices = [10, 20, 30];

export enum TipsError {
  DUPLICATE = 'Tip choice should be unique',
  EMPTY = 'Tip choice cannot be empty',
  MINIMUM = 'Minimum tip choice should be 1%'
}

export enum CommissionBasesSourceType {
  COMMISSION = 'COMMISSION',
  REFERRAL = 'REFERRAL'
}

export enum ReminderApplyOn {
  EXPIRY_DATE = 'EXPIRY_DATE',
  DUE_DATE = 'DUE_DATE'
}

export enum ReminderEntityType {
  ESTIMATES = 'ESTIMATES',
  INVOICE = 'INVOICES'
}

export enum ReminderDateTypeLabel {
  EXPIRY_DATE = 'expiry date',
  DUE_DATE = 'due date'
}
// Due Date Options for Invoice Settings
export const DUE_DATE_OPTIONS = [
  { id: 'due-on-receipt', name: 'Due on receipt', duration: 0, btnLabel: 'Due on receipt' },
  { id: '7-days', name: '7 days from issue date', duration: 7, btnLabel: '7 days' },
  { id: '14-days', name: '14 days from issue date', duration: 14, btnLabel: '14 days' },
  { id: '30-days', name: '30 days from issue date', duration: 30, btnLabel: '30 days' },
  { id: '45-days', name: '45 days from issue date', duration: 45, btnLabel: '45 days' },
  { id: '60-days', name: '60 days from issue date', duration: 60, btnLabel: '60 days' },
  { id: '90-days', name: '90 days from issue date', duration: 90, btnLabel: '90 days' }
];

export enum PartialPaymentOption {
  OFF_BY_DEFAULT = 'OFF_BY_DEFAULT',
  ON_BY_DEFAULT = 'ON_BY_DEFAULT',
  ALWAYS_ON = 'ALWAYS_ON'
}

export enum DiscountCalculationType {
  BEFORE_TAX = 'BEFORE_TAX',
  AFTER_TAX = 'AFTER_TAX'
}

export const DISCOUNT_CALCULATION_OPTIONS: {
  id: DiscountCalculationType;
  label: string;
  tooltip: string;
}[] = [
  {
    id: DiscountCalculationType.BEFORE_TAX,
    label: 'Apply discounts before tax (Recommended)',
    tooltip: 'Before-tax discounts reduce the taxable amount and provide greater savings to customers.'
  },
  {
    id: DiscountCalculationType.AFTER_TAX,
    label: 'Apply discounts after tax',
    tooltip: 'After-tax discounts are typically used for manufacturer rebates.'
  }
];

// Partial Payment Options for Invoice Settings
export const PARTIAL_PAYMENT_OPTIONS = [
  { id: PartialPaymentOption.ON_BY_DEFAULT, name: 'On by default' },
  { id: PartialPaymentOption.OFF_BY_DEFAULT, name: 'Off by default' },
  { id: PartialPaymentOption.ALWAYS_ON, name: 'Always on' }
];

export const SETTINGS_SECTION = {
  GENERAL: 'General',
  JOB_SETTINGS: 'Job settings',
  BILLING_AND_PAYMENTS: 'Billing and payments',
  ACCOUNTING_AND_PAY: 'Accounting and Pay'
} as const;
